module.exports = __webpack_public_path__ + "img/mobilehead.1c931282.png";